export enum MyBikeEvent {
    TOGGLE = 'myBike:toggle',
}
